import { render } from "./UserPanel.vue?vue&type=template&id=1d726bfc&scoped=true&ts=true"
import script from "./UserPanel.vue?vue&type=script&lang=ts"
export * from "./UserPanel.vue?vue&type=script&lang=ts"

import "./UserPanel.vue?vue&type=style&index=0&id=1d726bfc&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\miauerka\\web-projects\\mimafi-project\\mimawebapp\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d726bfc"]])

export default __exports__